function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0al{fill:#31D055;}\n\t.st1al{fill:#333333;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0al",
  d: "M49.47,24.72L30.45,13.75c-0.54-0.31-1.13-0.51-1.74-0.62c-0.35-0.37-0.75-0.69-1.19-0.95L8.51,1.22 c-1.65-0.95-3.69-0.95-5.34,0C1.52,2.17,0.5,3.94,0.5,5.84v21.93c0,0.6,0.11,1.18,0.3,1.73c-0.12,0.45-0.19,0.93-0.19,1.41v21.93 c0,1.9,1.02,3.67,2.67,4.62c0.82,0.48,1.75,0.71,2.67,0.71c0.92,0,1.84-0.24,2.67-0.71L27.63,46.5c0.46-0.26,0.86-0.6,1.22-0.97 c0.56-0.11,1.1-0.3,1.6-0.59l0,0l19.02-10.97c1.65-0.95,2.67-2.72,2.67-4.63C52.14,27.44,51.12,25.67,49.47,24.72z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1al",
  d: "M6.26,28.5l19.02-10.97c0.56-0.32,0.56-1.13,0-1.45L6.26,5.11C5.7,4.79,5,5.19,5,5.84v21.93 C5,28.42,5.7,28.82,6.26,28.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1al",
  d: "M6.37,53.57L25.39,42.6c0.56-0.32,0.56-1.13,0-1.45L6.37,30.18c-0.56-0.32-1.26,0.08-1.26,0.73v21.93 C5.11,53.49,5.81,53.89,6.37,53.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1al",
  d: "M28.2,41.04l19.02-10.97c0.56-0.32,0.56-1.13,0-1.45L28.2,17.65c-0.56-0.32-1.26,0.08-1.26,0.73v21.93 C26.95,40.95,27.64,41.36,28.2,41.04z"
})));

var SvgAquilaIcono = function SvgAquilaIcono(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.64 58.68",
    style: {
      enableBackground: "new 0 0 52.64 58.68"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAquilaIcono, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Aquila_Icono.606fc735.svg";
export { ForwardRef as ReactComponent };